/* eslint-disable max-len */
export default {
  CareConnect: 'CareConnect',
  Onboarding: 'Onboarding',
  Helmet: {
    title: 'Quilt: Form',
  },
  EditMode: {
    Cancel: 'Cancel',
    Save: 'Save',
  },
  Common: {
    Back: 'Back',
    Continue: 'Continue',
  },
  StartStep: {
    Title: 'Help us understand your family\'s care needs',
    Description: 'Answering a few additional questions will help us find the best caregiver for your family and provide accurate pricing information.',
    CareNeeds: 'Care needs',
    Skip: 'Skip For Now',
    Create: 'Create Care Plan',
  },
  CareRecipientInfo: {
    Title: 'Before we begin...',
    Description: 'Let\'s start with some basic information about the care recipient.',
    FullNameLabel: 'Full name of care recipient',
    DobLabel: 'Date of birth',
    AddressLabel: 'Address',
    AddressPlaceholder: '123 Main Street, Ottawa, ON',
  },
  FormStep: {
    Previous: 'Previous',
    Next: 'Next',
    Submit: 'Submit',
    Progress: '#{current} of #{total}',
    ProgressEmpty: '0 of 0',
    WhyAskingTitle: 'Why are we asking this?',
    WhyAskingBody: 'This information helps us better understand the care needs and provide more effective support. Please answer each question to the best of your ability. You will be able to review the plan with a care specialist to clarify.',
  },
  FormStepper: {
    More: '#{count} more',
  },
  FormProgressBar: {
    CareOverview: 'Care Overview',
    ScheduleAndQuote: 'Schedule & Quote',
    CarePlan: 'Care Plan',
    CaregiverMatching: 'Caregiver Matching',
  },
  Inputs: {
    OtherPlaceholder: 'Specify other option...',
    TextPlaceholder: 'Enter your response',
  },
  Summary: {
    NeedsAdded: '#{formTitle} needs added',
    SummaryTitle: '#{formTitle} summary',
    CaregiverRequirements: 'Caregiver requirements',
    NextForm: 'To #{formTitle}',
    DifficultyEasy: 'Easy to find',
    DifficultyMedium: 'Not easy to find',
    DifficultyHard: 'Difficult to find',
    DifficultyEasyDescription: 'You can expect around 10-15 caregivers in 3-5 days based on those requirements.',
    DifficultyMediumDescription: 'You can expect around 5-6 caregivers in 7-10 days based on your schedule and requirements.',
    DifficultyHardDescription: 'Some of your requirements may be difficult to fulfill. You can expect 1-2 caregivers in 10-15 days.',
  },
  Final: {
    Title: 'Care plan created',
    Description: 'Starting the perfect caregiver search as you read!',
    Summary: 'Care plan summary',
    LoadingTitle: 'Generating the perfect plan',
    LoadingDescription: 'This will take a moment.',
  },
  CareRecipientForm: {
    Title: 'Care Recipient Information',
    Description: 'Care recipient information to get started.',
    FullNameQuestion: 'Full name of care recipient',
    AgeQuestion: 'Age',
    AddressQuestion: 'Address',
  },
};
